import { Container } from '@mui/material'
import { Outlet } from 'react-router-dom'

const TemplateLogin = () => {
  return (
    <Container maxWidth="xl" sx={{ overflow: 'auto' }}>
      <Outlet />
    </Container>
  )
}

export default TemplateLogin
